export enum CompanySize {
    Small = 0,
    Medium = 1,
    Large = 2,
    Enterprise = 3
}